import { createContext, useContext, useEffect, useReducer } from "react";
import axios from "axios";
import ProductReducer from "../reducer/productReducer";

const AppContext = createContext();

const API =
  "http://ec2-34-197-250-249.compute-1.amazonaws.com/api/product_read";
// const API = 'https://api.pujakaitem.com/api/products';

const initialState = {
  isLoading: false,
  isError: false,
  products: [],
  featureProducts: [],
  searchProduct: [],
  singleProduct: {},
  isSingleLoading: false,
};

const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(ProductReducer, initialState);

  // const getProducts = async (url) => {
  //     dispatch({ type: 'SET_SINGLE_LOADING' });

  //     try {
  //         const res = await axios.get(url);
  //         const products = await res.data.products;
  //         // console.log(res);
  //         dispatch({ type: "SET_API_DATA", payload: products });

  //     } catch (error) {
  //         dispatch({ type: "API_ERROR" });
  //     }
  // };

  const getProducts = async (url) => {
    dispatch({ type: "SET_SINGLE_LOADING" });

    try {
      const res = await axios.post(url, { category: ["jewelry"] });
      const products = await res.data.data;
      dispatch({ type: "SET_API_DATA", payload: products });
    } catch (error) {
      dispatch({ type: "API_ERROR" });
    }
  };
  useEffect(() => {
    getProducts();
  }, []);

  const getSingleProduct = async (url) => {
    dispatch({ type: "SET_SINGLE_LOADING" });
    try {
      const res = await axios.post(url, {
        category: ["Diamond"],
        product_sku: sku,
      });
      const singleProduct = await res.data.data[0];
      // console.log(singleProduct);
      dispatch({ type: "SET_SINGLE_PRODUCT", payload: singleProduct });
    } catch (error) {
      dispatch({ type: "SET_SINGLE_ERROR" });
    }
  };

  const getSearchProduct = async (url) => {
    dispatch({ type: "SET_SINGLE_LOADING" });
    try {
      const res = await axios.post(url, {
        category: ["Diamond"],
        product_sku: sku,
      });
      const searchProduct = await res.data.data;
      // console.log('SEARCH_PRODUCT',searchProduct);
      dispatch({ type: "SEARCH_PRODUCT", payload: searchProduct });
    } catch (error) {
      dispatch({ type: "SET_SINGLE_ERROR" });
    }
  };

  return (
    <AppContext.Provider
      value={{ ...state, getSingleProduct, getSearchProduct }}
    >
      {children}
    </AppContext.Provider>
  );
};

// custom hook
const useProductContext = () => {
  return useContext(AppContext);
};

export { AppProvider, AppContext, useProductContext };
